






import { Vue, Component } from "vue-property-decorator";

@Component({})

export default class FormRow extends Vue {
    get columnsCount() {
        return this.$scopedSlots.default?.({})?.length ?? 0;
    }
}

